import { render, staticRenderFns } from "./studioDetail.vue?vue&type=template&id=f56ae7fe&scoped=true&"
import script from "./studioDetail.vue?vue&type=script&lang=js&"
export * from "./studioDetail.vue?vue&type=script&lang=js&"
import style0 from "./studioDetail.vue?vue&type=style&index=0&id=f56ae7fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56ae7fe",
  null
  
)

export default component.exports